/**
 * Bundle Price Manager
 * Version: 1.2.1
 * Fix : sélection du bon bouton ATC (bundle section uniquement) + section guard renforcé
 */

(function() {
  'use strict';

  class BundlePriceManager {
    constructor() {
      this.lastDetail = null;

      if (!document.querySelector('[data-bundle-selector]')) return;

      this.init();
    }

    // FIX: cherche le bouton ATC dans la même section que le bundle, pas dans tout le DOM
    getBundleButton() {
      const bundleContainer = document.querySelector('[data-bundle-selector]');
      if (!bundleContainer) return null;

      const bundleSection = bundleContainer.closest('section, [data-section-id]');

      if (bundleSection) {
        // Chercher dans la section du bundle uniquement
        return bundleSection.querySelector('[data-add-to-cart]') ||
               bundleSection.querySelector('[name="add"]');
      }

      // Fallback : prendre le dernier [data-add-to-cart] qui contient "panier" dans son texte
      const allAtcButtons = Array.from(document.querySelectorAll('[data-add-to-cart]'));
      const bundleBtn = allAtcButtons.find(b =>
        b.textContent.toLowerCase().includes('panier') ||
        b.textContent.toLowerCase().includes('sélectionnez')
      );
      return bundleBtn || allAtcButtons[allAtcButtons.length - 1];
    }

    init() {
      document.addEventListener('bundlePrice:change', (e) => {
        this.lastDetail = e.detail;
        this.updateButtonPrice(e.detail);
      });

      document.addEventListener('click', (e) => {
        const bundleContainer = document.querySelector('[data-bundle-selector]');
        if (!bundleContainer || !bundleContainer._bundleSelector) return;

        const button = e.target.closest('[data-add-to-cart], [name="add"]');
        if (!button) return;

        const bundleSection = bundleContainer.closest('section, [data-section-id]');
        const buttonSection = button.closest('section, [data-section-id]');
        if (bundleSection && buttonSection && bundleSection !== buttonSection) return;

        // FIX: ignorer les boutons quick-add des upsells
        if (button.dataset.quickAddBtn !== undefined) return;

        const items = bundleContainer._bundleSelector.getFormData();
        if (!items || items.length === 0) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        this.addBundleToCart(button, items);
      }, true);
    }

    addBundleToCart(button, items) {
      button.disabled = true;
      button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items })
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          console.error('Bundle add to cart error:', data.description);
          button.disabled = false;
          button.classList.remove('is-loading');
          return;
        }

        const openDrawer = () => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.cartDrawerIsOpen) {
            cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
          }
        };

        const onProductAdded = () => {
          clearTimeout(fallbackTimer);
          openDrawer();
        };

        document.addEventListener('theme:product:added', onProductAdded, { once: true });

        const fallbackTimer = setTimeout(() => {
          document.removeEventListener('theme:product:added', onProductAdded);
          openDrawer();
        }, 2000);

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

        button.classList.remove('is-loading');
        button.disabled = false;
      })
      .catch(err => {
        console.error('Bundle add to cart error:', err);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
    }

    updateButtonPrice(detail) {
      // FIX: utiliser getBundleButton() au lieu de querySelector global
      const button = this.getBundleButton();
      if (!button) return;

      const buttonText = button.querySelector('[data-add-to-cart-text]') ||
                         button.querySelector('.product__submit__text') ||
                         button.querySelector('.btn__text') ||
                         button.querySelector('span:not(.visually-hidden)') ||
                         button;

      if (!buttonText) return;

      if (!detail.hasSelections) {
        buttonText.textContent = detail.emptyText || 'Compose ton pack';
        button.disabled = true;
        button.classList.add('btn--disabled', 'disabled');
        return;
      }

      const formattedPrice = this.formatMoney(detail.totalPrice);

      if (detail.basePriceTotal > detail.totalPrice) {
        const basePriceFormatted = this.formatMoney(detail.basePriceTotal);
        buttonText.innerHTML = `Ajouter au panier • <s style="opacity: 0.6;">${basePriceFormatted}</s> ${formattedPrice}`;
      } else {
        buttonText.textContent = `Ajouter au panier • ${formattedPrice}`;
      }

      button.disabled = false;
      button.classList.remove('btn--disabled', 'disabled');
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',') + ' €';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BundlePriceManager());
  } else {
    new BundlePriceManager();
  }

  window.BundlePriceManager = BundlePriceManager;

})();